import React from "react";
import GuideList from "../../Components/Guide/GuideList";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const GuideListPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <GuideList pageNumber={query.pageNumber} type={query.type} />
    </React.Fragment>
  );
};

export default GuideListPage;
